import * as React from "react"
import { cn } from "@merels/ui"

export interface MateNameProps {
  name: string
}

export const MateName = React.forwardRef<HTMLSpanElement, MateNameProps>(
  ({ name }, ref) => {
    return (
      <span
        ref={ref}
        className={cn("text-xs font-medium text-inverse bg-overlay px-1.5 py-0.5 rounded inline-block")}
      >
        {name}
      </span>
    )
  }
)
MateName.displayName = "MateName"
